<template>
    <div class="media widthz">
        <div class="navGo flex ">
            <span @click="goHomg()">首页></span>
            <span>详情</span>
        </div>

        <section class="widthWhite lu_bo">
            <div class="pj-tit ">
                <p>{{detail.Name}}</p>
                <figure class="flex zhong">
                    <img src="../../image/zs_time.png" />
                    <figcaption>开始时间：{{detail.BeginTime}}</figcaption>
                </figure>
                <figure class="flex zhong">
                    <img src="../../image/zs_phone.png" />
                    <figcaption>联系电话：{{detail.Phone}}</figcaption>
                </figure>
            </div>
        </section>

        <section class="widthWhite">
            <h6>活动内容</h6>
            <article class="details_nei" id="detailInfo"></article>
        </section>
    </div>
</template>
<script>
export default {
    name: 'media',
    data() {
        return {
            detailId: 0,
            detail: {}
        };
    },
	mounted() {
		console.log('页面传参' + this.$route.query);
		this.detailId = this.$route.query.Id ? this.$route.query.Id : 0;
		this.GetDetail();
	},
    methods: {
        // 返回首页
        goHomg() {
            this.$router.push('/home');
        },
		// 获取详情
		GetDetail: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetActivityDetail?Id=' + that.detailId,
				'GET', {},
				function(res) {
					console.log('获取详情');
					console.log(res);
					if (res.code === 0) {
						that.detail = res.data;
						document.getElementById('detailInfo').innerHTML = res.data.Detail;
					}
				},
				function(res) {}
			);
		}
    }
};
</script>
<style scoped>

    .pj-tit figure figcaption {
        font-size: 14px;
        color: #808080;
    }

    .pj-tit figure img {
        display: block;
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }

    .pj-tit figure {
        margin-top: 10px;
    }

.widthWhite h6 {
    font-size: 16px;
    color: #333;
    padding-left: 10px;
    position: relative;
    font-weight: normal;
    margin-bottom: 30px;
}

.widthWhite h6::after {
    content: '';
    width: 4px;
    height: 16px;
    border-radius: 50px;
    background-color: #444444;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -8px;
    z-index: 1;
}

.pj-tit {
    width: 100%;
}
.pj-tit p {
    width: 60%;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: bold;
}
.pj-num {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.pj-num img {
    width: 24px;
    height: 24px;
    display: block;
}
.pj-num span {
    font-size: 12px;
    color: #666;
}

.video_div video {
    width: 100%;
    height: 662px;
    overflow: hidden;
    display: block;
}

.lu_bo {
    margin-bottom: 30px;
    padding: 20px 40px !important;
}

.details_nei {
    font-size: 14px;
}
.widthWhite hgroup p span {
    margin: 0 20px;
}

.widthWhite hgroup p {
    margin-top: 20px;
    font-size: 12px;
    color: #666;
}

.widthWhite hgroup h6 {
    font-weight: normal;
    font-size: 16px;
    text-align: center;
}

.widthWhite hgroup {
    padding: 0 0 20px 0;
    margin-bottom: 20px;
    border-bottom: solid 1px #e6e6e6;
}
</style>
